import { type TreeNode } from '@direct-frontend/components';

export function checkboxesToNodeIds(
    checkboxes: [string, boolean][],
    nodeMap: Map<string, TreeNode>,
    autoIncludeChildren: boolean = true
): string {
    if (!checkboxes.length) {
        return '';
    }

    const uncheckedMap = new Map<string, boolean>();

    checkboxes.forEach(([id, checked]) => {
        if (!checked) {
            uncheckedMap.set(id, true);
        }
    });

    const resultIds = new Set<string>();

    const addChildren = (nodeId: string) => {
        const node = nodeMap.get(nodeId);

        if (!node?.children) {
            return;
        }

        for (const child of node.children) {
            if (uncheckedMap.has(child.id)) {
                continue;
            }

            resultIds.add(child.id);
            addChildren(child.id);
        }
    };

    checkboxes.forEach(([id, checked]) => {
        if (!checked) {
            return;
        }

        resultIds.add(id);

        if (autoIncludeChildren) {
            addChildren(id);
        }
    });

    return Array.from(resultIds).join(',');
}
